import React, { Fragment } from 'react';
import { Intro, CompleteSentence } from 'dea-core';
import img from '../../assets/images/U1-T1-11A.svg';

const data = [
  {
    beforeChoice: 'Prescription opioids are for',
    afterChoice: '.',
    choices: [
      'providing temporary relief from severe pain',
      'any pain you might experience'
    ]
  }
];

const correctInput = {
  0: 'providing temporary relief from severe pain'
};

const feedback = {
  // TODO do not let this feedback make it into the final version
  success: {
    title: 'Correct!',
    body: ''
  },
  error: {
    title: 'That’s incorrect!',
    body: 'Opioids are not suitable for just any type of pain.'
  },
  retry: {
    title: 'Not quite.',
    body: ''
  }
};

export default {
  title: 'Question 1',
  path: '/evaluate/question-1',
  content: (
    <Fragment>
      <Intro
        title="What do You Think?"
        direction="Select the word/phrase that best completes each sentence."
        img={img}
      />

      <CompleteSentence
        data={data}
        feedback={feedback}
        correctInput={correctInput}
        score={10}
        partiallyCorrectScoring={true}
      />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/evaluate/Question1.js